import React, { useEffect, useState } from "react";

const Progress = () => {
  const [currentValue, setCurrentValue] = useState(0);
  const maxValue = 5000000;

  useEffect(() => {
    fetch("/progress.txt")
      .then((res) => res.text())
      .then((text) => {
        const number = parseInt(text.trim().replace(/,/g, ""), 10);
        if (!isNaN(number)) {
          setCurrentValue(number);
        }
      })
      .catch((err) => console.error("Failed to load progress file:", err));
  }, []);

  const percentage = Math.min((currentValue / maxValue) * 100, 100);

  return (
    
    <>
    <p className="text-white fw-bold fs-6 mb-0 merriweather-sans">Token Sales Progress</p>
    <div style={styles.container}>
      <div style={styles.topLabels}>
       <div>
         <p className="merriweather-sans mb-0">Raised</p>
        <p className="text-white merriweather-sans mb-0">0 DIAG</p>
       </div>
       <div>
         <p className="mb-0">Total</p>
         <p className="text-white merriweather-sans">50,000,000,000 DIAG</p>
       </div>
      </div>

      <div style={styles.progressBackground}>
        <div
          style={{
            ...styles.progressFill,
            width: `${percentage}%`,
          }}
        />
        <div
          style={{
            ...styles.thumb,
            left: `calc(${percentage}% - 8px)`,
          }}
        />
      </div>

      <div style={styles.currentValue}>
        {currentValue.toLocaleString()} DIAG
      </div>
    </div>
   
    </>
  );
};

const styles = {
  container: {
    maxWidth: "500px",
    margin: "0px auto",
    textAlign: "center",
    fontFamily: "sans-serif",
    color: "#0c1f3a",
  },
  topLabels: {
    display: "flex",
    justifyContent: "space-between",
    fontWeight: "bold",
   
  },
  progressBackground: {
    position: "relative",
    backgroundColor: "#0c1f3a",
    height: "12px",
    borderRadius: "10px",
    overflow: "hidden",
  },
  progressFill: {
    height: "100%",
    background: "linear-gradient(to right, #00c6ff, #0072ff)",
    borderRadius: "10px 0 0 10px",
    transition: "width 0.4s ease-in-out",
  },
  thumb: {
    position: "absolute",
    top: "0px",
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    background: "#fff",
    border: "3px solid #00c6ff",
    transition: "left 0.4s ease-in-out",
  },
  currentValue: {
    marginTop: "10px",
    fontSize: "16px",
    fontWeight: "600",
    color: "#fff",
  },
};

export default Progress;
